
import * as Yup from 'yup';

export const getInitialValues = (attributes: any) => {
  let { appointment_preferences, contact_preferences } = attributes || {}

  return {
    appointment_preferences: {
      early_morning: appointment_preferences?.early_morning ?? false,
      afternoon: appointment_preferences?.afternoon ?? false,
      evening: appointment_preferences?.evening ?? false,
      weekend: appointment_preferences?.weekend ?? false,
    },
    contact_preferences: {
      text_message: contact_preferences?.text_message ?? false,
      email: contact_preferences?.email ?? false,
      phone_call: contact_preferences?.phone_call ?? false
    }
  }
}

export const validationSchema = Yup.object().shape({
  appointment_preferences: Yup.object().shape({
    early_morning: Yup.boolean(),
    afternoon: Yup.boolean(),
    evening: Yup.boolean(),
    weekend: Yup.boolean(),
  }),
  contact_preferences: Yup.object().shape({
    text_message: Yup.boolean(),
    email: Yup.boolean(),
    phone_call: Yup.boolean(),
  })
})

export const timePreferences = [
  { title: 'early_morning', label: 'Early morning' },
  { title: 'afternoon', label: 'Afternoon' },
  { title: 'evening', label: 'Evening' },
  { title: 'weekend', label: 'Weekend' }
]

export const reachingMethods = [
  { title: 'text_message', label: 'Text message' },
  { title: 'email', label: 'Email' },
  { title: 'phone_call', label: 'Phone call' }
]
